import { useCallback } from 'react';
import { StringParam, useQueryParams } from 'use-query-params';

import { SpecialsSortKey, SPECIALS_SORT_QUERY_PARAM } from './specials-sort.types';

const config = {
  [SPECIALS_SORT_QUERY_PARAM]: StringParam,
};

function isValidSortKey(value: string | null | undefined): value is SpecialsSortKey {
  return value != null && Object.values(SpecialsSortKey).includes(value as SpecialsSortKey);
}

export function useSpecialsSort(): {
  sortKey: SpecialsSortKey | undefined;
  setSortKey: (key: SpecialsSortKey) => void;
} {
  const [queryParams, setQueryParams] = useQueryParams(config);

  const raw = queryParams[SPECIALS_SORT_QUERY_PARAM];
  const sortKey = isValidSortKey(raw) ? raw : undefined;

  const setSortKey = useCallback(
    (key: SpecialsSortKey) => {
      setQueryParams({ [SPECIALS_SORT_QUERY_PARAM]: key });
    },
    [setQueryParams]
  );

  return { sortKey, setSortKey };
}
